export default "__VITE_ASSET__CfhRyMi8__"